import http from 'util/http'

/** 获取文章分类 */
export function getArticleCategory() {
  return http.get('/newxyrj/public/article/category', {})
}
/**
 * 获取专题列表
 * @param {object} param 分页
 * @param {number} param.pageindex
 * @param {number} param.pagesize
 */
export function getTopicList({
  pageindex,
  pagesize = 10,
}: {
  pageindex: number
  pagesize?: number
}) {
  return http.post('/newxyrj/public/topic/list', { pageindex, pagesize })
}
/**
 * 获取热门视频
 * @param {object} param 分页
 * @param {number} param.pageindex
 * @param {number} param.pagesize
 */
export function getHotList({
  pageindex,
  pagesize = 10,
}: {
  pageindex: number
  pagesize?: number
}) {
  return http.post('/newxyrj/public/article/hot/list', { pageindex, pagesize })
}
/**
 * 新上课程
 * @param {object} param 分页
 * @param {number} param.pageindex
 * @param {number} param.pagesize
 */
export function getNewList({
  pageindex,
  pagesize = 10,
}: {
  pageindex: number
  pagesize?: number
}) {
  return http.post('/newxyrj/public/article/new/list', { pageindex, pagesize })
}
/**
 * 获取文章详情
 * @param {number} id 文章id
 */
export function getArticleDetail(id: number) {
  return http.get('/newxyrj/public/article/id', { id })
}
/**
 * 获取分类下面的所有视频
 * @param {string} id 类型id
 * @param {object} param 分页
 * @param {number} param.pageindex 分页的起始索引
 * @param {number} param.pagesize 每页返回的行数
 */
export function getCategoryVideo(
  id: number,
  { pageindex, pagesize }: { pageindex: number; pagesize?: number },
) {
  return http.get('/newxyrj/public/article/category/id', {
    category_id: id,
    pageindex,
    pagesize,
  })
}
/**
 * 获取专题下面的所有视频
 * @param {number} id 专题id
 * @param {object} param 分页
 * @param {number} param.pageindex
 * @param {number} param.pagesize
 */
export function getTopicVideo(
  id: number,
  { pageindex, pagesize = 10 }: { pageindex: number; pagesize?: number },
) {
  return http.post('/newxyrj/public/article/category/id', {
    topic_id: id,
    pageindex,
    pagesize,
  })
}
/**
 * 查看评论列表
 * @param {number} id 文章id
 * @param {object} param 分页
 * @param {number} param.pageindex
 * @param {number} param.pagesize
 */
export function getCommentList(
  id: number,
  { pageindex, pagesize = 10 }: { pageindex: number; pagesize?: number },
) {
  return http.get('/newxyrj/public/article/comment/list', {
    article_id: id,
    pageindex,
    pagesize,
  })
}
/**
 * 对评论点赞
 * @param {number} id 回答id
 */
export function likeAnswer(id: number) {
  return http.post('/newxyrj/public/article/comment/praise', {
    article_comment_id: id,
  })
}
/**
 * 对已点赞的作答取消点赞
 * @param {number} id 回答id
 */
export function unlikeAnswer(id: number) {
  return http.post('/newxyrj/public/article/comment/praise/cancel', {
    article_comment_id: id,
  })
}
/**
 * 文章点赞
 * @param {number} id 回答id
 */
export function likeArticle(id: number) {
  // const token = sessionStorage.getItem('token')
  return http.post('/newxyrj/public/article/praise', {
    article_id: id,
    // token,
  })
}
/**
 * 取消文章点赞
 * @param {number} id 回答id
 */
export function unlikeArticle(id: number) {
  // const token = sessionStorage.getItem('token')
  return http.post('/newxyrj/public/article/cancelpraise', {
    article_id: id,
    // token,
  })
}
/**
 * 发表评论
 * @param {number} id 文章id
 * @param {string} comment 内容
 */
export function postAnswer(id: number, comment: string) {
  return http.post('/newxyrj/public/article/comment/submit', {
    article_id: id,
    comment,
  })
}
/**
 * 猜你喜欢
 * @param {number} id 文章id
 * @param {number} id 分类id
 * @param {number} id 专题id
 */
export function guess(id: number, categoryId: number, topicId: number) {
  return http.get('/newxyrj/public/article/guess/like', {
    article_id: id,
    category_id: categoryId,
    topic_id: topicId,
  })
}

/**
 * 相关课程
 * @param {number} id 文章id
 */
export function related(id: number) {
  return http.get('/newxyrj/public/related/article/list', {
    article_id: id,
  })
}

/**
 * 文章学习统计接口
 * @param {number} id 文章id
 */
export function statistics(id: number, random: string) {
  return http.get('/access/statistics', {
    noLoading: true,
    id,
    random,
  })
}
